import React, { useState } from "react";
import emailjs from "emailjs-com";
import { Card, Form, Button } from "react-bootstrap";
import axios from "axios";

export default function SendArtDownloadEmail() {
  const [email, setEmail] = useState("");
  const [artTitle, setArtTitle] = useState("");
  const [originalUrl, setOriginalUrl] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [urlGenerated, setUrlGenerated] = useState(false);

  const handleGenerateLink = async () => {
    if (!originalUrl) {
      setStatus("⚠️ Please enter the original Cloudinary file URL first.");
      return;
    }

    try {
      setLoading(true);
      setStatus("Generating expiring link...");
      const publicId = originalUrl
        .split("upload/")[1]
        .replace(/^v\d+\//, "");

      const response = await axios.post(
        "https://api-shipping-28612190fdf4.herokuapp.com/cloudLink",
        { publicId }
      );

      setOriginalUrl(response.data.signedUrl);
      setUrlGenerated(true);
      setStatus("✅ Expiring link generated! You can now send the email.");
    } catch (error) {
      console.error(error);
      setStatus("❌ Failed to generate expiring link.");
    } finally {
      setLoading(false);
    }
  };

  const handleSendEmail = (e) => {
    e.preventDefault();

    if (!originalUrl) {
      setStatus("⚠️ No URL to send. Please generate the expiring link first.");
      return;
    }

    const templateParams = {
      to_name: email,
      art_title: artTitle || "Your Artwork",
      download_link: originalUrl,
    };

    emailjs
      .send(
        "service_tw1l015",
        "template_1i9k21h",
        templateParams,
        "y1aOwrYwZfD1C_s4I"
      )
      .then(
        () => {
          setStatus("✅ Email sent successfully!");
          setEmail("");
          setArtTitle("");
          setOriginalUrl("");
          setUrlGenerated(false);
        },
        (error) => {
          console.error("Error sending email:", error);
          setStatus("❌ Failed to send email. Check console for details.");
        }
      );
  };

  return (
    <div
      style={{
        display: "flex",
        padding: "20px",
        backgroundColor: "#f8f9fa",
      }}
    >
      <Card
        style={{
          width: "100%",
          height:"auto",
          maxWidth: "420px",
          padding: "20px",
          borderRadius: "18px",
          boxShadow: "0 4px 25px rgba(0,0,0,0.1)",
          backgroundColor: "#fff",
        }}
      >
        <h3
          style={{
            textAlign: "center",
            fontWeight: "600",
            marginBottom: "20px",
            fontSize: "1.5rem",
          }}
        >
          Send Artwork Download Email
        </h3>

        <Form onSubmit={handleSendEmail}>
          <Form.Group style={{ marginBottom: "15px" }}>
            <Form.Label>Customer Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="customer@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ fontSize: "1rem", padding: "0.5rem" }}
            />
          </Form.Group>

          <Form.Group style={{ marginBottom: "15px" }}>
            <Form.Label>Artwork Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g. Golden Sunset"
              value={artTitle}
              onChange={(e) => setArtTitle(e.target.value)}
              style={{ fontSize: "1rem", padding: "0.5rem" }}
            />
          </Form.Group>

          <Form.Group style={{ marginBottom: "15px" }}>
            <Form.Label>Original Cloudinary URL</Form.Label>
            <Form.Control
              type="url"
              placeholder="https://res.cloudinary.com/.../artworks/filename.jpg"
              value={originalUrl}
              onChange={(e) => setOriginalUrl(e.target.value)}
              required
              style={{ fontSize: "1rem", padding: "0.5rem" }}
            />
          </Form.Group>

          <Button
            variant="secondary"
            onClick={handleGenerateLink}
            disabled={loading}
            style={{ width: "100%", fontSize: "1rem", padding: "0.5rem", marginBottom: "15px" }}
          >
            {loading ? "Generating..." : "Generate Expiring Link"}
          </Button>

          {urlGenerated && (
            <Button
              type="submit"
              variant="dark"
              style={{ width: "100%", fontSize: "1rem", padding: "0.5rem" }}
            >
              Send Email
            </Button>
          )}
        </Form>

        {status && (
          <p
            style={{
              marginTop: "15px",
              textAlign: "center",
              fontWeight: "500",
              fontSize: "0.95rem",
              color: status.includes("✅")
                ? "green"
                : status.includes("❌")
                ? "red"
                : "#555",
            }}
          >
            {status}
          </p>
        )}
      </Card>
    </div>
  );
}
